import React from "react";
import RegistrationWizardState from "../registrationWizardState";

const WelcomeIntroStep = () => {
  const account = RegistrationWizardState.getAccount();
  const clinicName = RegistrationWizardState.getClinicName();
  const firstName =
    account.firstName?.trim() || RegistrationWizardState.getStepData().firstName.value?.trim();

  return (
    <div className="clinician-onboard-welcome-intro">
      <h2 className="clinician-onboard-welcome-intro__title">Welcome to {clinicName}</h2>
      {firstName && (
        <p className="clinician-onboard-welcome-intro__greeting">
          Hi {firstName}, let&apos;s finish setting up your account.
        </p>
      )}
      <p className="clinician-onboard-welcome-intro__description">
        We&apos;ll guide you through a few quick steps to complete your clinician profile.
      </p>
    </div>
  );
};

export default WelcomeIntroStep;
